import { createFileRoute, useLoaderData } from '@tanstack/react-router';
import { ChatV2 } from '../../../../features/chat/pages/ChatV2';
import { assistantKeys } from '../../../../features/marketplace/services/queries/assistantApiQueries';
import { assistantAPI } from '../../../../features/marketplace/services/api/assistantAPI';

export const Route = createFileRoute(
  '/_app/project/$projectId/$conversationId'
)({
  component: RouteComponent,
  loader: ({ context }) => {
    return context.queryClient.ensureQueryData({
      queryKey: assistantKeys.list(),
      queryFn: () => assistantAPI.listAssistantsAsync(),
      staleTime: Infinity,
    });
  },
});

function RouteComponent() {
  const assistantDetails = useLoaderData({
    from: '/_app/project/$projectId/$conversationId',
  });
  return <ChatV2 assistantDetails={assistantDetails} />;
}
